import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function PictureImage({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M2.99609 13.0004L4.29179 11.7047C4.74413 11.2524 5.35764 10.9983 5.99734 10.9983C6.63704 10.9983 7.25055 11.2524 7.70288 11.7047L11.9998 16.0017M7.00076 21.0038L13.2986 14.706C14.2405 13.764 15.7677 13.764 16.7096 14.706L20.6504 18.6468M21.0036 17.0021C21.0036 19.2122 19.212 21.0038 17.0019 21.0038H6.99776C4.7877 21.0038 2.99609 19.2122 2.99609 17.0021V6.99794C2.99609 4.78788 4.7877 2.99628 6.99776 2.99628H17.0019C19.212 2.99628 21.0036 4.78788 21.0036 6.99794V17.0021Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default PictureImage;